import { getStudioAppUrl } from './app-url'

const origin = getStudioAppUrl()

export const STUDIO_APP_ROUTES = {
  API_PLATFORM: `${origin}/platform/`,
  MCP: `${origin}/mcp`,
} as const
